module.exports = __webpack_public_path__ + "static/media/menuHotspot.6368e4e8.svg";